import { ThriveFragmentFragment } from '../../__generated__/graphql';
import AppImage from '../../components/AppImage';
import { Paragraph } from '../../components/Text';
import Section from '../../layout/Section';
import SectionTitle from '../../layout/Section/SectionTitle';
import { ContentBlock } from '../types';

import style from './thrive.module.css';

const Thrive: ContentBlock<ThriveFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.thrive;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor="black"
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.thriveContainer}
    >
      <div className={style.thriveTextContainer}>
        <SectionTitle className={style.thriveHeading}>
          {contentBlockProps.title}
        </SectionTitle>

        <Paragraph fontSize={20}>
          {contentBlockProps.description}
        </Paragraph>

        <Paragraph
          fontSize={20}
          fontWeight={700}
        >
          {contentBlockProps.descriptionFooter}
        </Paragraph>
      </div>

      {contentBlockProps.image && (
        <AppImage
          className={style.thriveImage}
          fallbackHeight={550}
          fallbackWidth={460}
          image={contentBlockProps.image}
        />
      )}
    </Section>
  );
};

export default Thrive;
